import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const updateOtoritas = createAsyncThunk(
  "otoritas/update",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "updateOtoritas",
        data,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getOtoritas = createAsyncThunk(
  "Otoritas/get",
  async ({ Username }, thunkAPI) => {
    let formData = new FormData();
    formData.append("userName", Username);
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "getOtoritas",
        formData,
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

const initialState = {
  message: "",
  isApproveListFetching: false,
  isApproveListSuccess: false,
  isGetFetching: false,
  isGetSuccess: false,
  isGetError: false,
  isInsertFetching: false,
  isInsertSuccess: false,
  isInsertError: false,
  isOtoritasUpdateFetching: false,
  isOtoritasUpdateSuccess: false,
  isOtoritasUpdateError: false,
  isMinFetching: false,
  isMinSuccess: false,
  isMinError: false,
  isMinAllFetching: false,
  isMinAllSuccess: false,
  isMinAllError: false,
  isUpdateFetching: false,
  isUpdateSuccess: false,
  isUpdateError: false,
  isotoritasSuccess: false,
  errorMessage: "",
};

export const userOtoritasSlice = createSlice({
  name: "userOtoritas",
  initialState,
  reducers: {},
  extraReducers: {
    // OtoritasUpdate
    [updateOtoritas.fulfilled]: (state, { payload }) => {
      state.isOtoritasUpdateFetching = false;
      state.isOtoritasUpdateSuccess = true;
      state.message = payload.message;
      //   window.location.reload(false);
      return state;
    },
    [updateOtoritas.rejected]: (state, { payload }) => {
      state.isOtoritasUpdateFetching = false;
      state.isOtoritasUpdateError = true;

      state.errorMessage = payload.message;
    },
    [updateOtoritas.pending]: (state) => {
      state.isOtoritasUpdateFetching = true;
    },

    [getOtoritas.fulfilled]: (state, { payload }) => {
      state.isotoritasFetching = false;
      state.isotoritasSuccess = true;
      state.otoritasData = payload.data;
      return state;
    },
    [getOtoritas.rejected]: (state, { payload }) => {
      state.isotoritasFetching = false;
      state.isotoritasError = true;
      state.errorMessage = payload.message;
    },
    [getOtoritas.pending]: (state) => {
      state.isotoritasFetching = true;
      state.isotoritasSuccess = false;
    },
  },
});

export const OtoritasSlice = (state) => state.userOtoritas;
